<template>
  <div class="setMemberType">
    <div class="layer">
      <div class="inner">
        <button type="button" class="btnClose" @click="onClose"><span class="blind">close</span></button>
        <h2 class="layerTitle">
          {{locale.guesttype_setting}}
          <span v-if="defaultValue" class="checkbox onoff">
            <input type="checkbox" id="defaultVal" v-model="guestInfo[0].setDefault">
            <label for="defaultVal">{{guestInfo[0].setDefault ? locale.setting_common : locale.setting_individual}}</label>
          </span>
        </h2>
        <div v-if="guestInfo">
          <table class="table">
            <thead>
              <tr>
                <th class="center">{{locale.guesttype}}</th>
                <th class="center">{{locale.state_private}}</th>
                <th class="center">{{locale.change_total}}</th>
                <th class="center">{{locale.activate}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in guestInfo"
                :key="item.id"
                :class="{active: item.active}">
                <td class="item center guestType">
                  <p>{{item.name[lang]}}</p>
                  ({{item.id}})
                </td>
                <td class="center">
                  <div class="checkbox">
                    <input type="checkbox" :id="`${item.id}_hide`" v-model="item.hide">
                    <label :for="`${item.id}_hide`">{{locale.state_private}}</label>
                  </div>
                </td>
                <!-- 금액: 총액 -->
                <td>
                  <!-- <div class="checkbox">
                    <input type="checkbox" :id="`${item.id}_discount`" v-model="item.discount">
                    <label :for="`${item.id}_discount`">{{locale.change_total}}</label>
                  </div> -->
                  <!-- 증감율 -->
                  <div class="setIncDec">
                    <div class="tdBox" :class="{disabled: item.active && !item.discount}">
                      <div class="checkbox radio">
                        <input type="radio" :id="`${item.id}_percent`" :name="`${item.id}_total`" :checked="item.percent.active || false" @change="setDiscount(item.id, 'percent')">
                        <label :for="`${item.id}_percent`"> {{locale.change_rate}}</label>
                      </div>
                      <div class="tdFrame mt5">
                        <!-- 증감 +- -->
                        <div class="incdec">
                          <div class="checkbox">
                            <input type="radio" :id="`${item.id}_percent_inc`" :name="`${item.id}_percent_incdec`" value="inc" v-model="item.percent.incDec">
                            <label :for="`${item.id}_percent_inc`">+</label>
                          </div>
                          <div class="checkbox">
                            <input type="radio" :id="`${item.id}_percent_dec`" :name="`${item.id}_percent_incdec`" value="dec" v-model="item.percent.incDec">
                            <label :for="`${item.id}_percent_dec`">-</label>
                          </div>
                        </div>
                        <!-- //증감 +- -->
                        <!-- 액수 -->
                        <input type="text" class="input sizeS right" v-model="item.percent.value" @input="inputNumber(item.id, 'percent')"> %
                        <!-- //액수 -->
                      </div>
                    </div>
                    <!-- //증감율 -->
                    <!-- 증감액 -->
                    <div class="tdBox" :class="{disabled: item.active && !item.discount}">
                      <div class="checkbox radio">
                        <input type="radio" :id="`${item.id}_price`" :name="`${item.id}_total`" :checked="item.price.active || false" @change="setDiscount(item.id, 'price')">
                        <label :for="`${item.id}_price`">{{locale.change_price}}</label>
                      </div>
                      <div class="tdFrame mt5">
                        <!-- 증감 +- -->
                        <div class="incdec">
                          <div class="checkbox">
                            <input type="radio" :id="`${item.id}_price_inc`" :name="`${item.id}_price_incdec`" value="inc" v-model="item.price.incDec">
                            <label :for="`${item.id}_price_inc`">+</label>
                          </div>
                          <div class="checkbox">
                            <input type="radio" :id="`${item.id}_price_dec`" :name="`${item.id}_price_incdec`" value="dec" v-model="item.price.incDec">
                            <label :for="`${item.id}_price_dec`">-</label>
                          </div>
                        </div>
                        <!-- //증감 +- -->
                        <!-- 액수 -->
                        <input type="text" class="input sizeSm right" v-model="item.price.value" @input="inputNumber(item.id, 'price')">
                        <!-- //액수 -->
                      </div>
                    </div>
                    <!-- //증감액 -->
                  </div>
                  <p v-if="!validate[index]" class="mt5 colorRed">{{locale.validate_change_price}}</p>
                </td>
                <!-- 금액: //총액 -->
                <td class="item center">
                  <div class="checkbox">
                    <input type="checkbox" :id="`${item.id}_active`" v-model="item.active">
                    <label :for="`${item.id}_active`">{{locale.activate}}</label>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="btns">
            <button
              v-if="btnApplyAll"
              type="button"
              class="btn btnPrimary btnFull"
              :disabled="validate.filter(x => !x).length > 0"
              @click="apply(true)">{{locale.apply_all}}</button>
            <button
              v-else
              type="button"
              class="btn btnPrimary btnFull"
              :disabled="validate.filter(x => !x).length > 0"
              @click="apply(false)">{{locale.apply}}</button>
          </div>
        </div>
        <p v-else class="noData">{{locale.guesttype_nodata}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import regExp from '@/common/regExp'

export default {
  name: 'GuestType',
  props: [
    'locale',
    'guestType',
    'btnApplyAll',
    'defaultValue'
  ],
  computed: {
    guestTypes () {
      return this.$store.getters['setting/getData'].guestType
    },
    validate () {
      const valid = this.guestInfo.map(x => {
        return !(x.percent.incDec === 'dec' && x.percent.value >= 100)
      })
      return valid
    },
    lang () {
      return this.$store.state.setting.lang.default
    }
  },
  mounted () {
    /**
     * guestType: 설정값(json파일에서)
     * 식별타입은 모두 서버에서
     * setInfo: 식별타입별 정보(프론트에서)
     */
    const defaultInfo = this._.cloneDeep(this.setInfo)
    if (this.guestTypes) {
      const types = this.guestTypes.map(x => {
        const hasData = this.guestType && this.guestType.find(f => f.id === x.id)
        return {
          ...x,
          ...defaultInfo,
          ...hasData,
          name: x.name // 이름은 공통세팅 데이터로
        }
      })
      this.guestInfo = this._.cloneDeep(types)
    }
  },
  data () {
    return {
      setInfo: {
        active: false,
        hide: false,
        discount: true,
        setDefault: false,
        percent: {
          active: false,
          incDec: 'dec',
          value: 0
        },
        price: {
          active: false,
          incDec: 'dec',
          value: 0
        }
      },
      guestInfo: []
    }
  },
  methods: {
    inputNumber (id, info) {
      const item = this.guestInfo.find(x => x.id === id)
      const value = Number(regExp.numberOnly(item[info].value))
      item[info].value = value
    },
    setDiscount (id, info) {
      const other = info === 'percent' ? 'price' : 'percent'
      this.guestInfo = this.guestInfo.map(x => {
        return {
          ...x,
          [info]: {
            ...x[info],
            active: x.id === id ? true : x[info].active
          },
          [other]: {
            ...x[other],
            active: x.id === id ? false : x[other].active
          }
        }
      })
    },
    onClose () {
      if (window.confirm(this.locale.confirm_guesttype_cancel)) {
        this.$emit('close')
      }
    },
    apply (applyAll) {
      if (window.confirm(this.locale.confirm_apply)) {
        const guestInfo = this.guestInfo.map(x => {
          return {
            ...x,
            discount: true
          }
        })
        this.$emit('close')
        this.$emit('apply', guestInfo)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.layer .inner {
  max-width: 800px;
}
.layerTitle {
  display: flex;
  align-items: center;
  .checkbox {
    margin-left: auto;
    margin-right: 0;
    font-size: 14px;
  }
}
.table td {
  white-space: nowrap;
  border-left: 1px solid $color-lgrey2;
  .checkbox {
    margin-right: 0;
  }
  .sizeSm {
    width: 7.5em;
  }
  .tdFrame {
    position: relative;
    padding-left: 20px;
  }
  .validateMessage {
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-bottom: 6px;
    padding: 5px;
    font-size: 12px;
    color: $color-white;
    border-radius: 2px;
    background-color: $color-red;
    transform: translate(-50%, 0);
    &:after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 6px;
      height: 6px;
      margin-bottom: -3px;
      margin-left: -3px;
      background-color: $color-red;
      transform: rotate(45deg);
    }
  }
  .guestType {
    font-size: 12px;
    p {
      font-size: 16px;
    }
  }
}
tr {
  td:not(.item) {
    opacity: 0.5;
  }
  .item {
    .checkbox label {
      min-width: 80px;
      min-height: 0;
      padding: 8px 15px;
      text-align: center;
      color: $color-white;
      border-radius: 4px;
      background-color: $color-lgrey;
      &:before,
      &:after {
        display: none;
      }
    }
  }
  &.active {
    td:not(.item) {
      opacity: 1;
    }
    .item {
      .checkbox label {
        background-color: $color-primary;
      }
    }
  }
}
.setIncDec {
  display: flex;
  .tdBox {
    flex: 1;
    &.disabled {
      opacity: 0.5;
    }
  }
  .incdec {
    position: absolute;
    top: 0;
    left: 0;
    width: 20px;
    height: 100%;
    .checkbox {
      display: block;
      height: 50%;
      label {
        min-height: 0;
        width: 20px;
        height: 100%;
        padding: 0;
        text-align: center;
        font-size: 18px;
        line-height: 100%;
        border: 1px solid $color-lgrey;
        border-right: none;
        background-color: $color-white;
        &:before,
        &:after {
          display: none;
        }
      }
      & + .checkbox {
        label {
          line-height: calc(100% - 1px);
          border-top: none;
        }
      }
      input:checked + label {
        color: $color-white;
        background-color: $color-dark;
      }
    }
  }
}
.btns {
  max-width: 180px;
  margin: 30px auto 0;
}
.noData {
  padding: 60px 0 90px;
  text-align: center;
  font-size: 1.2em;
}
</style>
